module.exports = __webpack_public_path__ + "files/49af882b76e569ef65b7f89597770cb1.png";